import { WizardContext, WizardStep } from './wizard/wizardMachine'

export enum QueryParams {
  LoanOfferId = 'loanOfferId',
}

export interface FormContextValue extends Omit<WizardContext, 'isNewApplication'> {
  step: WizardStep
  proceed: () => void
  goBack: () => void
  goBackToStatus: () => void
  exit: () => Promise<void>
  exitWithConfirmDialog: () => void
}
